export const VALIDATION_CONSTANTS = {
  MESSAGE: {
    MAX_LENGTH: 4000,
    MIN_LENGTH: 1,
  },

  FILE: {
    // Align with Synapse `max_upload_size` / ingress proxy-body-size (100m on alpha).
    MAX_SIZE_MB: 100,
    MAX_SIZE_BYTES: 100 * 1024 * 1024,
    ALLOWED_IMAGE_TYPES: ['image/jpeg', 'image/png', 'image/gif', 'image/webp'],
    ALLOWED_VIDEO_TYPES: ['video/mp4', 'video/webm', 'video/quicktime'],
    ALLOWED_DOCUMENT_TYPES: [
      'application/pdf',
      'application/msword',
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
      'application/vnd.ms-excel',
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      'text/plain',
      'text/csv',
      'application/zip',
      'application/x-zip-compressed',
      'application/vnd.rar',
      'application/x-rar-compressed',
    ],
  },

  CHAT: {
    TITLE_MAX_LENGTH: 100,
    DESCRIPTION_MAX_LENGTH: 500,
    MAX_MEMBERS: 1000,
  },

  USER_NAME: {
    MIN_LENGTH: 2,
    MAX_LENGTH: 50,
    MAX_NUMERIC_CHECK_LENGTH: 15,
  },
} as const
